<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                ref="cardFormRef"
                :callbacks="{ refreshData: refreshObjectCard, saveData: saveObjectCard, isDirty: null }"
                :meta="objectCardMeta.cardMeta"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
                :use-default-buttons="true"
                :toolbar-items="customToolbarItems"
                components-path="views/contracts/object/object-card/field-wrappers"
                @is-dirty="onIsDirty"
            />
        </div>
        <widgets-side-menu local-storage-key="objectWidgetList" />
        <widgets-popup :user-data="userData" />
    </div>
</template>
<script setup>
import CardForm from '@/components/card-component/card-form.vue';
import objectCardMeta from '@/views/contracts/object/object-card/object-card-meta';
import {
    setIsDirtyValue,
    setTabReadyToSaveValue,
    setTabTitle,
} from '@/layouts/main-layout/components/navigation-bars-data';
import { ref } from 'vue';
import { useStore } from 'vuex';
import WidgetsSideMenu from '@/components/card-component/widgets-side-menu.vue';
import WidgetsPopup from '@/components/card-component/widgets-popup.vue';
import { getObjectCard, updObjectCard } from '@/service/counteragent-service';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();
const cardFormRef = ref();
const userData = ref();
const customToolbarItems = [];
store.dispatch('createWidgetMetaList', objectCardMeta.getObjectWidgetList());

const onIsDirty = e => {
    userData.value = e.userData;
    const fnc = () => e.userData;
    setTabReadyToSaveValue(true);
    setIsDirtyValue(e.value, saveObjectCard, fnc, 'object-card', 'object-card');
};

const refreshObjectCard = async () => {
    const data = await getObjectCard(route.params.id);
    if (data.result && data.success && data.data) {
        setTabTitle(`${data.data['num_obj']} ${data.data['name']}`);
    }
    return data;
};

const saveObjectCard = async data => {
    return await updObjectCard(data);
};
</script>
<script>
export default {
    name: 'object-card',
};
</script>
